"use client";

import { useEffect, useState } from "react";

import AdminLayout from "../../components/layout/AdminLayout/AdminLayout";
import dashboardService from "../../services/dashboard/dashboardService";
import "./Dashboard.css";

export default function Dashboard() {

    const [dashboard, setDashboard] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        loadDashboard();
    }, []);

    const loadDashboard = async () => {

        try {

            setLoading(true);
            setError("");

            const response = await dashboardService.getDashboard();

            if (response.success) {

                setDashboard(response.data);

            } else {

                setError(response.message || "Failed to load dashboard.");

            }

        } catch (error) {

            console.error("Dashboard API Error:", error);

            setError("Unable to load dashboard data.");

        } finally {

            setLoading(false);

        }

    };


    const dashboardCards = dashboard
        ? [
            {
                title: "News",
                count: dashboard.newsCount,
                icon: "bi-newspaper",
                className: "dashboard-card-blue"
            },
            {
                title: "Testimonials",
                count: dashboard.testimonialCount,
                icon: "bi-chat-quote",
                className: "dashboard-card-purple"
            },
            {
                title: "Gallery",
                count: dashboard.galleryCount,
                icon: "bi-images",
                className: "dashboard-card-pink"
            },
            {
                title: "Videos",
                count: dashboard.videoCount,
                icon: "bi-play-btn",
                className: "dashboard-card-red"
            },
            {
                title: "Events",
                count: dashboard.eventCount,
                icon: "bi-calendar-event",
                className: "dashboard-card-orange"
            },
            {
                title: "Awards",
                count: dashboard.awardCount,
                icon: "bi-trophy",
                className: "dashboard-card-yellow"
            },
            {
                title: "Clients",
                count: dashboard.clientCount,
                icon: "bi-people",
                className: "dashboard-card-green"
            },
            {
                title: "Team Members",
                count: dashboard.teamMemberCount,
                icon: "bi-person-badge",
                className: "dashboard-card-teal"
            },
            {
                title: "FAQs",
                count: dashboard.faqCount,
                icon: "bi-question-circle",
                className: "dashboard-card-indigo"
            }
        ]
        : [];


    return (

        <AdminLayout>

            <div className="dashboard-container">

                {/* Header */}
                <div className="dashboard-header">

                    <div>
                        <h2>Dashboard</h2>

                        <p>
                            Welcome to Website CMS Admin Panel.
                        </p>
                    </div>

                    <button
                        className="dashboard-refresh-btn"
                        onClick={loadDashboard}
                        disabled={loading}
                    >
                        <i className="bi bi-arrow-clockwise"></i>

                        {loading ? " Loading..." : " Refresh"}
                    </button>

                </div>


                {/* Error */}
                {error && (

                    <div className="alert alert-danger">
                        <i className="bi bi-exclamation-circle me-2"></i>
                        {error}
                    </div>

                )}


                {/* Loading */}
                {loading && !dashboard && (

                    <div className="dashboard-loading">

                        <div className="spinner-border text-primary"></div>

                        <p>Loading dashboard...</p>

                    </div>

                )}


                {/* Dashboard Cards */}
                {!loading && dashboard && (

                    <div className="row g-4">

                        {dashboardCards.map((item, index) => (

                            <div
                                className="col-xl-3 col-lg-4 col-md-6"
                                key={index}
                            >

                                <div
                                    className={`dashboard-card ${item.className}`}
                                >

                                    <div className="dashboard-card-content">

                                        <div>

                                            <span className="dashboard-card-title">
                                                {item.title}
                                            </span>

                                            <h3>
                                                {item.count}
                                            </h3>

                                            <span className="dashboard-card-label">
                                                Total {item.title}
                                            </span>

                                        </div>


                                        <div className="dashboard-icon">

                                            <i className={`bi ${item.icon}`}></i>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        ))}

                    </div>

                )}

            </div>

        </AdminLayout>

    );

}
